module.exports = __webpack_public_path__ + "img/products_big_can_green.e53bb73c.png";